import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
    providedIn: "root",
})
export class CourbeService {
    constructor(private http: HttpClient) { }


    list(dossierID:number,
          isdata:boolean=false,
          options: any = {}): Observable<JSONRpcResponse> {
	    
	    options["data"]=isdata;
	
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.courbe:list",
            params: {
	            id: dossierID,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

    

    get(code: string,
          dossierID:number=null,
          isdata:boolean=false,
           options: any = {}): Observable<JSONRpcResponse> {
        options["data"]=isdata;
        if (dossierID>0)
           options["dossierid"]=dossierID;
        
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.courbe:get",
            params: {
                id: code,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    
    export(code: string,
          dossierID:number=null,
          image:any,
           options: any = {}): Observable<JSONRpcResponse> {
        options["image"]=image;
        if (dossierID>0)
           options["dossierid"]=dossierID;
        
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.courbe:export",
            params: {
                id: code,
                options: options,
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
    
     

}
